import { combineReducers } from '@reduxjs/toolkit';
import { alertReducer } from 'shared/slices/admin';
import { configReducer } from 'shared/slices/admin/config';
import { idReducer } from 'shared/slices/admin/id';
import { loaderReducer } from 'shared/slices/admin/loader';
import { titleReducer } from 'shared/slices/admin/title';

export const projectEditorReducer = combineReducers({
  id: idReducer,
  config: configReducer,
  title: titleReducer,
  alert: alertReducer,
  loader: loaderReducer,
});

export type TProjectEditorState = ReturnType<typeof projectEditorReducer>;
